import { gql } from '__generated__';

export default gql(`
  mutation EditCurrentUser($input: EditCurrentUserInput!) {
    editCurrentUser(input: $input) {
      ...CurrentUserFields
    }
  }
`);
